export const SP_ORDER_CLIENT_CREATE = "SP_ORDER_CLIENT_CREATE";
export const SP_ORDER_CLIENT_CREATE_SUCCESS = "SP_ORDER_CLIENT_CREATE_SUCCESS";
export const SP_ORDER_CLIENT_CREATE_ERROR = "SP_ORDER_CLIENT_CREATE_ERROR";
export const SP_ORDER_CLIENTS_LIST_ALL = "SP_ORDER_CLIENTS_LIST_ALL";
export const SP_ORDER_CLIENTS_LIST_ALL_SUCCESS = "SP_ORDER_CLIENTS_LIST_ALL_SUCCESS";
export const SP_ORDER_CLIENTS_LIST_ALL_ERROR = "SP_ORDER_CLIENTS_LIST_ALL_ERROR";